import { inject } from '@angular/core';
import { CanActivateFn, RedirectCommand, Router } from '@angular/router';
import { map, of } from 'rxjs';

import { AuthService } from '@core/auth.service';
import { TenantContextService } from '@core/tenant-context.service';
import { AuthPathsService } from '@core/multi-tenant-auth';

export const studentRedirectGuard: CanActivateFn = () => {
  const router = inject(Router);
  const tenantContextService = inject(TenantContextService);
  const authService = inject(AuthService);
  const authPaths = inject(AuthPathsService);

  const tenant = tenantContextService.getTenant();
  const portalType = authService.getCurrentPortalType();

  if (!tenant) {
    return of(true);
  }

  return authService
    .isAuthenticated()
    .pipe(
      map((isAuthenticated) =>
        isAuthenticated
          ? new RedirectCommand(router.parseUrl('/'))
          : new RedirectCommand(router.parseUrl(authPaths.getLoginPath(portalType)))
      )
    );
};
